import { __assign, __rest } from "tslib";
import React from 'react';
import CentaurCard from './CentaurCard';
import DeviationDumbView from '../DeviationViews/Dumbo';
import { desktopSize, mobileSize } from './sizes';
import { withMobileContext } from '../Context/MobileContext';
export var DeviationCentaurCard = function (_a) {
    var deviation = _a.deviation, isMobile = _a.isMobile, centaurProps = __rest(_a, ["deviation", "isMobile"]);
    var size = isMobile ? mobileSize : desktopSize;
    return (React.createElement(CentaurCard, __assign({}, centaurProps, { thumb: deviation && React.createElement(DeviationDumbView, __assign({ deviation: deviation }, size)) })));
};
DeviationCentaurCard.displayName = 'DeviationCentaurCard';
export default withMobileContext(DeviationCentaurCard);
//# sourceMappingURL=DeviationCentaurCard.js.map